// extracted by mini-css-extract-plugin
module.exports = {"container":"Auctions-form_container__4JKTm","form":"Auctions-form_form__VrbxK","name-email-inputs":"Auctions-form_name-email-inputs__oGmnR"};